var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-client-table", {
    staticClass: "vue-custom-table no-pagination w-100",
    attrs: {
      data: _vm.getClients,
      columns: _vm.columns,
      options: _vm.options,
      name: _vm.tableName,
    },
    scopedSlots: _vm._u([
      {
        key: "appId",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm.infoType === "Mortgage"
              ? _c("div", { staticClass: "d-flex flex-row" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "regular text-gray my-auto text-capitalize",
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(row.applicationId) + "\n      "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "firstColumn",
        fn: function (ref) {
          var row = ref.row
          return [
            _c(
              "div",
              { staticClass: "d-flex flex-row" },
              [
                _vm.infoType === "Mortgage"
                  ? _c(
                      "router-link",
                      {
                        staticClass:
                          "text-primary clickable bold link-to-application",
                        attrs: { to: _vm.getApplicationLink(row) },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.hideModal.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(row.givenName) +
                            " " +
                            _vm._s(row.familyName) +
                            "\n      "
                        ),
                      ]
                    )
                  : _c(
                      "h4",
                      {
                        staticClass:
                          "regular text-gray my-auto text-capitalize",
                      },
                      [
                        row.givenName
                          ? [
                              _vm._v(
                                "\n          " +
                                  _vm._s(row.givenName) +
                                  "\n        "
                              ),
                            ]
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "font-italic text-light-gray text-capitalize",
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("global.words.empty")) +
                                    "\n        "
                                ),
                              ]
                            ),
                      ],
                      2
                    ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "secondColumn",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "d-flex flex-row" }, [
              _vm.infoType === "Mortgage"
                ? _c(
                    "h4",
                    {
                      staticClass: "regular text-gray my-auto text-capitalize",
                    },
                    [
                      row.propertyAddress
                        ? _c("span", [_vm._v(_vm._s(row.propertyAddress))])
                        : _c("span", { staticClass: "d-none" }, [
                            _vm._v(_vm._s(_vm.$t("application-form.property"))),
                          ]),
                    ]
                  )
                : _c(
                    "h4",
                    {
                      staticClass: "regular text-gray my-auto text-capitalize",
                    },
                    [
                      row.familyName
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.familyName) +
                                "\n        "
                            ),
                          ]
                        : _c(
                            "span",
                            {
                              staticClass:
                                "font-italic text-light-gray text-capitalize",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("global.words.empty")) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ],
                    2
                  ),
            ]),
          ]
        },
      },
      {
        key: "description",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("span", { attrs: { id: "follow-up-" + row.followUpId } }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$options.filters.truncateText(row.description, 25)
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("notification-popover", {
              attrs: { target: "follow-up-" + row.followUpId },
              scopedSlots: _vm._u(
                [
                  {
                    key: "popoverContent",
                    fn: function () {
                      return [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(row.rawDescription) },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
      {
        key: "mortgage",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm.infoType === "Mortgage"
              ? _c("div", { staticClass: "d-flex flex-row" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "regular text-gray my-auto text-capitalize",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            row.isExistingMortgage
                              ? _vm.$t("global.doorr.existingMortgage")
                              : _vm.$t("global.doorr.requestedMortgage")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "mortgageType",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm.infoType === "Mortgage"
              ? _c("div", { staticClass: "d-flex flex-row" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "regular text-gray my-auto text-capitalize",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "global.count." + row.mortgageType.toLowerCase()
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "date",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "d-flex flex-row" }, [
              _c(
                "h4",
                { staticClass: "regular text-gray my-auto text-capitalize" },
                [_vm._v("\n        " + _vm._s(_vm.dateText(row)) + "\n      ")]
              ),
            ]),
          ]
        },
      },
      {
        key: "coApplicant",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm.isCoapplicantBirthday(row.mainApp)
              ? _c(
                  "p",
                  {
                    staticClass:
                      "ml-0 badge status-badge is-default bg-light-gray complete px-2",
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$tc("global.doorr.coapplicant", 1)) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "board",
        fn: function (ref) {
          var row = ref.row
          var index = ref.index
          return [
            _vm.showBoardOptions
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-row justify-content-end d-sm-block d-none",
                    },
                    [
                      _vm.shouldShowViewOnBoard(row)
                        ? _c("view-on-board", {
                            attrs: { profiles: _vm.formattedProfileData(row) },
                          })
                        : [
                            _c(
                              "a",
                              {
                                ref: "addToBoardDropdown-" + index,
                                staticClass:
                                  "btn clickable action-button btn-white dropdown-toggle btn-sm mr-2 w-100",
                                attrs: {
                                  role: "button",
                                  "data-toggle": "dropdown",
                                  "data-boundary": "scrollParent",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("application.listing.addToBoard")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("boards-dropdown", {
                              attrs: {
                                id: "board-selection-container",
                                boards: _vm.BOARDS,
                              },
                              on: {
                                select: function (_, ref) {
                                  var boardId = ref.boardId

                                  return _vm.addClient(row, boardId, index)
                                },
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }